import {BehaviorSubject, forkJoin, forkJoin as observableForkJoin, Observable, of, Subscription} from 'rxjs';
import {Constants} from './../../commons/Constants';

import {concatMap, map, mergeMap} from 'rxjs/operators';
import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AccessGroup, Role, User} from 'vasat';

import {MapService} from '../../commons/map.service';
import {AppService} from '../../commons/app.service';
import {AclService} from '../../commons/acl/acl.service';
import {Account, AccountPlan, FourDService, Project} from '4d-mapper';
import {MatCheckbox, MatDialog, MatSnackBar} from '@angular/material';
import {AddUserDialog} from './user-add.dialog';
import {FormControl} from '@angular/forms';
import {ShareProjectDialog} from './share-project/share-project-dialog.component';
import {AppBaseComponent} from '../../commons/AppBaseComponent';
import { XsApplicationEventsService } from '../../xs/services/events/application-events.service';

import {TranslateService} from '@ngx-translate/core';
import { UsersComponent, UserStub } from './users.component';


interface ProjectACLStub{
    project:Project
    role?:FormControl // todo TYPE an ACL
    scratched:boolean
    valid:boolean
}
@Component({
  selector: 'userdetails-comp',
  templateUrl: './user_details.component.html',
  styleUrls: ['./users.component.scss']
})
export class UsersDetails extends AppBaseComponent implements OnInit, OnDestroy {

   @Input()
   userStub:UserStub

   loading = false
   
   projects = new BehaviorSubject<ProjectACLStub[]>([])

  tmp:any = [];

  roles:Role[]
  addProj:Project
  canSave = false
  constructor(public fourD: FourDService, public service: AppService, public permissions: AclService, public router: Router,
    public snackBar: MatSnackBar, public dialog: MatDialog, private activeRoute: ActivatedRoute, applicationEvents:XsApplicationEventsService,
     private t:TranslateService,private userEditor:UsersComponent) {
    super(service, router, snackBar, dialog, applicationEvents );
       
     
  
  }

  init(){

    this.projects.subscribe(s => {
      this.canSave = s.find(ss => ss.scratched) && !s.find(ss => !ss.role)
      console.log(s)
    })
    this.fourD.V.searchByObject(Role).equals("desc","4D Mapper|4D User").queryObservable().subscribe(s => {
      this.roles = s.items
      this.refresh()
    })
    
  }
  refresh(){
    if(this.userStub){
      this.loading = true
      this.fourD.searchFor(Project).equals('shareUsers',this.userStub.user.id).equals('forUser',this.userStub.user.id).queryObservable().subscribe(r => {
        this.projects.next(r.items.map(r => {
          var fc = new FormControl()
          fc.setValue(r['roles'])
   
          
          return { project:r, role:fc,scratched:false, valid:true}}))
        this.loading = false
      })
    }
  }
  ngOnChanges(){
    this.refresh()
  }

  removeUser(){
      this.openConfirmDelete(() => {
        (this.userStub.isInvite?
          this.fourD.activeTeam.invitedUsers.removeObservable(this.userStub.user)
          :
          this.userStub.group.users.removeObservable(this.userStub.user)
        ).subscribe(_ => {
          this.openSnackBarInfo('USER_ADMIN.USER_DELETED')
          this.userEditor.curUser = null
          this.userEditor.userList.next(this.userEditor.userList.value.filter(u => u != this.userStub))
      })
      },this.userStub.user.name)
  }
  onRolesChange(cur:ProjectACLStub){
    cur.scratched = true
    cur.valid = cur.role.value.length
  }

  addProject( p:Project = null ){

    
    p.shareUsers.addObserveable(this.userStub.user).subscribe(_ => {
      this.refresh()
      this.openSnackBarInfo('USER_ADMIN.PROJECT_SHARED')
    },
    e => this.openSnackBarError(e.messsage)
    )
    
  }

  showAddProjects:boolean = false;

  addProjects() {
    this.showAddProjects = true;
  }
  closeAddProjects() {
    this.showAddProjects = false;
  }

  zz:number = 0;

  hasProject( currentProjects:any, p:Project = null ) {
    if ( !p ) {
      return false;
    }
    // if ( this.zz++ > 50 ) {
      // this.zz = 0;
      let test = currentProjects.find ( pp => pp.project.id == p.id );
      // console.log('### hasProject', currentProjects, p, test );
      if ( test ) {
        return true;
      }
    // }
    return false;
  }

  addUserRole(stub:ProjectACLStub){
    var ss = ''
    stub.role.value.forEach(s1 => ss += s1 + ',')
    ss = ss.substring(0,ss.length - 1)
    this.fourD.V.put('/api/Project/' + stub.project.id + '.acl/' + ss + '/' + this.userStub.user.id,{}).subscribe(_ => 
      this.openSnackBarInfo('USER_ADMIN.PROJECT_ROLES')
      ,
    e => this.openSnackBarError(e.messsage)
    )
  }
  removeUserFromProj(stub:ProjectACLStub){
    this.openConfirmDelete(() => {
      this.fourD.V.delete('/api/Project/' + stub.project.id + '.acl/' + this.userStub.user.id,{}).subscribe(_ => {
        this.openSnackBarInfo('USER_ADMIN.REMOVED')
        this.refresh()
      },
      e => this.openSnackBarError(e.messsage)
      )
    },stub.project.name)
  }
  setAdmin(){
    this.fourD.activeTeam.accountGroups.queryObservable().pipe(concatMap(ag => {
      var admins = ag.items.find(a => a.uid.endsWith("_admins"))
      var normal = ag.items.find(a => !a.uid.endsWith("_admins"))

      if(this.userStub.isAdmin){
        return forkJoin([
          admins.users.addObserveable(this.userStub.user),
          normal.users.removeObservable(this.userStub.user)
        ])
        
      }
      else{
        return forkJoin([
          admins.users.removeObservable(this.userStub.user),
          normal.users.addObserveable(this.userStub.user)
        ])
      }
    })).subscribe(s => 
      this.openSnackBarSuccess("GENERIC.UPDATED")
    , e => this.openSnackBarError(e.message))
    
  }
}   
